export default "/static/dashboard/build/app/img/v2/418c60336683c7474cd19a4341c4b8e8.png";